import { Alert } from '@rikstv/shared-components';
import classNames from 'classnames';
import { useFeatureFLags, useViaplayBruddFeatures } from '../../../hooks/useFeatureFlags';
import styles from './ViaplayNegotiationsAlert.module.css';

export const ViaplayNegotiationsAlert = ({matchOverviewListSize}: {matchOverviewListSize?:boolean}) => {
  const flags = useFeatureFLags();

  const showViaplayWarning = useViaplayBruddFeatures(flags);
  if (!showViaplayWarning) {
    return null;
  }

  return (
    <Alert
      intent="info"
      dismissible={false}
      className={classNames(styles.infoAlert, { [styles.desktopMargins]: matchOverviewListSize })}
      heading="Pågående forhandlinger med Viaplay."
    >
      På grunn av pågående forhandlinger er alt innhold fra Viaplay Group for øyeblikket utilgjengelig. Dette inkluderer
      kanalene TV3, TV3+, TV6, V sport-kanalene, V Film premiere, V film action og V series, og Viaplay tilleggspakker.
    </Alert>
  );
};
